export const LOGIN_API = 'auth/login'

export const ADD_PROFILE = 'api/profiles'
export const GET_QRCODE = 'api/barcodes'

export const SIGNIN = 'signin'
export const GET_CARD = '/cards'
export const SAVE_CARD = '/cards'
